// Port of api/fuel/app/classes/controller/api/monty/hindex/untrack.php
import DB from 'offline/db'
import User from 'offline/model/user'
import HindexType from 'offline/model/hindex/type'
import HindexTrack from 'offline/model/hindex/track'
import { currentUser, invalid, payload, persist } from './shared'

export default function(params) {
	var user = currentUser(params)
	if (!user) return invalid()

	var track = HindexTrack.record({
		where: [
			['hindex_id', '=', parseInt(params.index, 10) || 0],
			['user_id', '=', user.get_id()],
			['hindex_id', '<>', 1]
		]
	})

	if (!track) return invalid()

	var type = HindexType.with_id(track.get_hindex_id())
	if (!type) return invalid()

	DB.run('DELETE FROM hindex_track WHERE track_id = ?', [track.get_id()])
	DB.run('DELETE FROM log_user_hindex WHERE hindex_id = ? AND user_id = ?', [track.get_hindex_id(), user.get_id()])
	DB.run('UPDATE user SET user_count_hindex_added = CASE WHEN user_count_hindex_added > 0 THEN user_count_hindex_added - 1 ELSE 0 END WHERE user_id = ?', [user.get_id()])
	DB.run('UPDATE hindex_type SET hindex_users = CASE WHEN hindex_users > 0 THEN hindex_users - 1 ELSE 0 END WHERE hindex_id = ?', [track.get_hindex_id()])

	if (!type.get_public() && type.get_user_id() === user.get_id()) {
		DB.run('DELETE FROM hindex_type WHERE hindex_id = ?', [type.get_id()])
	}

	var freshUser = User.with_id(user.get_id())
	return persist(payload(freshUser, type))
}
